import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../../../../core/layout/Breadcrumb';

const PlacementTestItemHistoryBreadcrumbs = (props) => (
  <Breadcrumb
    fetching={props.fetching}
    crumbs={[
      {
        text: 'Placement Tests',
        link: '/placement-test',
      },
      {
        text: 'Placement Test Items',
        link: `/placement-test/${props.placementTestItem.grammarPlacementTestLevel.id}`,
      },
      {
        text: 'History',
      },
    ]}
  />
);

PlacementTestItemHistoryBreadcrumbs.propTypes = {
  fetching: PropTypes.bool,
  placementTestItem: PropTypes.shape({
    grammarPlacementTestLevel: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

PlacementTestItemHistoryBreadcrumbs.defaultProps = {
  fetching: false,
};

export default PlacementTestItemHistoryBreadcrumbs;
